"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DOMAINS = exports.DOMAINS_ENVS = void 0;

var _types = require("./types");

var _DOMAINS_ENVS;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DOMAINS_ENVS = (_DOMAINS_ENVS = {}, _defineProperty(_DOMAINS_ENVS, _types.EBDomains.EVENTBRITE, _types.EBEnvs.PROD), _defineProperty(_DOMAINS_ENVS, _types.EBDomains.EVBSTAGE, _types.EBEnvs.STAGE), _defineProperty(_DOMAINS_ENVS, _types.EBDomains.EVBQA, _types.EBEnvs.QA), _defineProperty(_DOMAINS_ENVS, _types.EBDomains.EVBDEV, _types.EBEnvs.DEV), _DOMAINS_ENVS);
exports.DOMAINS_ENVS = DOMAINS_ENVS;
var DOMAINS = [_types.EBDomains.EVENTBRITE, _types.EBDomains.EVBSTAGE, _types.EBDomains.EVBQA, _types.EBDomains.EVBDEV];
exports.DOMAINS = DOMAINS;
//# sourceMappingURL=constants.js.map